/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum objednávky`
};

const da_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Ordredato`
};

const de_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelldatum`
};

const en_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Order date`
};

const es_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha del pedido`
};

const fr_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Date de commande`
};

const hu_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés dátuma`
};

const it_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data ordine`
};

const nl_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Besteldatum`
};

const pl_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data zamówienia`
};

const pt_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data do pedido`
};

const sv_order_date = /** @type {(inputs: {}) => string} */ () => {
	return `Beställningsdatum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_date", locale)
	if (locale === "cs") return cs_order_date(inputs)
	if (locale === "da") return da_order_date(inputs)
	if (locale === "de") return de_order_date(inputs)
	if (locale === "en") return en_order_date(inputs)
	if (locale === "es") return es_order_date(inputs)
	if (locale === "fr") return fr_order_date(inputs)
	if (locale === "hu") return hu_order_date(inputs)
	if (locale === "it") return it_order_date(inputs)
	if (locale === "nl") return nl_order_date(inputs)
	if (locale === "pl") return pl_order_date(inputs)
	if (locale === "pt") return pt_order_date(inputs)
	return sv_order_date(inputs)
};